import React from "react";
import Modal from "react-modal";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { WidgetButton } from "@fidget/common/components/widgetButton/widgetButton";
import styles from "./forgetMeDialog.css";

interface Props {
  isOpen: boolean;
  finish: () => void;
  close: () => void;
}

interface State {
  isPendingConfirmation: boolean;
}

export class ForgetMeDialog extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);

    this.state = {
      isPendingConfirmation: true
    };
  }

  render() {
    return (
      <Modal
        isOpen={this.props.isOpen}
        shouldCloseOnEsc
        className={styles["confirmation-dialog"]}
        overlayClassName={styles["confirmation-overlay"]}
        shouldCloseOnOverlayClick
        onRequestClose={this.close}
        ariaHideApp={false}
      >
        {(this.state.isPendingConfirmation && (
          <>
            <div className={styles["confirmation-text"]}>
              {intl.formatMessage("widget.forgetMe.dialog.question")}
            </div>
            <div className={styles["confirmation-buttons"]}>
              <WidgetButton onClick={() => this.close()} buttonStyle={"secondary"}>
                <div>{intl.formatMessage("widget.forgetMe.dialog.cancel")}</div>
              </WidgetButton>
              <WidgetButton onClick={() => this.confirm()} buttonStyle={"primary"}>
                <div>{intl.formatMessage("widget.forgetMe.dialog.ok")}</div>
              </WidgetButton>
            </div>
          </>
        )) || (
          <>
            <div className={styles["confirmation-text"]}>
              {intl.formatMessage("widget.forgetMe.dialog.confirmation.label")}
            </div>
            <div className={styles["confirmation-subtext"]}>
              {intl.formatMessage("widget.forgetMe.dialog.confirmation.text")}
            </div>
          </>
        )}
      </Modal>
    );
  }

  confirm() {
    setTimeout(() => {
      this.close();
      this.props.finish();
    }, 2000);
    this.setState({ isPendingConfirmation: false });
  }

  close() {
    this.setState({ isPendingConfirmation: true });
    this.props.close();
  }
}
